<template>
  <component :is="link ? 'a' : 'span'"
    class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-soft text-sm"
    :class="link ? 'text-primary-dark hover:text-primary-focus cursor-pointer' : 'text-gray-dark'"
    :href="link || undefined"
    @click="onClick"
  >
    <template v-if="scope === SCOPE.GLOBAL">
      <vs-icon :icon="ICON.GLOBAL" size="1rem" class="leading-none"/>
      <span>Global</span>
    </template>

    <template v-else-if="scope === SCOPE.BOT">
      <bot-icon class="w-3.5 h-3.5"/>
      <span class="truncate">{{ botName }}</span>
    </template>

    <template v-else-if="scope === SCOPE.BOT_MARKET">
      <bot-icon class="w-3.5 h-3.5"/>
      <span class="truncate">{{ botName }}</span>
      <span class="mx-0.5 text-gray">·</span>
      <vs-icon :icon="ICON.MARKET" size="1rem" class="leading-none"/>
      <span class="truncate">{{ marketName }}</span>
    </template>
  </component>
</template>

<script>
import BotIcon from '@/assets/images/icons/BotIcon.vue'
import { VARIABLE_SCOPE } from '@/store/constants'
import { SCOPE_ICON } from '@/constants/variable-scope.constants'

export default {
  name: 'VariableScopeBadge',

  components: { BotIcon },

  props: {
    scope: { type: String, required: true },
    botName: { type: String, default: '' },
    marketName: { type: String, default: '' },
    botLink: { type: String, default: null },
    marketLink: { type: String, default: null }
  },

  data() {
    return {
      SCOPE: VARIABLE_SCOPE,
      ICON: SCOPE_ICON
    }
  },

  computed: {
    // The navigable target for the current scope (bot settings, or the market panel).
    link() {
      if (this.scope === VARIABLE_SCOPE.BOT) return this.botLink
      if (this.scope === VARIABLE_SCOPE.BOT_MARKET) return this.marketLink
      return null
    }
  },

  methods: {
    onClick(event) {
      if (!this.link) return
      event.preventDefault()
      this.$emit('navigate', this.link)
    }
  }
}
</script>
